module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Monster-Little-Devil-Web-1280.7ba22cc5.jpg";